<template>
  <div class="page-login-v3 layout-full th">
    <div class="page vertical-align text-xs-center" >
      <div class="page-content vertical-align-middle">
        <div class="brand">
          <img class="brand-img" src="/static/images/byteark-loading-white.png" alt="logo account" width="180">
          <h2 class="brand-text font-size-24 grey-100"></h2>
        </div>
        <div class="panel">
          <div class="panel-body">
            <h1 class="title" v-if="(this.step < 2)">{{ $t('register.labels.register') }}</h1>
            <h1 class="title" v-else>{{ $t('register.action.registerSuccess') }}</h1>
            <div class="pearls row">
              <div class="pearl current col-xs-4" v-bind:class="{ 'done' : (this.step === 0) }">
                <div class="pearl-icon"><i class="icon md-account" aria-hidden="true"></i></div>
                <span class="pearl-title">{{ $t('account.labels.account') }}</span>
              </div>
              <div class="pearl col-xs-4" v-bind:class="{ 'current' : (this.step > 0) }">
                <div class="pearl-icon"><i class="icon md-accounts-list" aria-hidden="true"></i></div>
                <span class="pearl-title">{{ $t('team.title') }}</span>
              </div>
              <div class="pearl col-xs-4" v-bind:class="{ 'current' : (this.step > 1) }">
                <div class="pearl-icon"><i class="icon md-check" aria-hidden="true"></i></div>
                <span class="pearl-title">{{ $t('register.action.finish') }}</span>
              </div>
            </div>
            <alert v-show="showAlert"
              alertClass="alert-dismissible"
              type="danger">
              <span>{{errorResponse}}</span>
            </alert>
            <form v-on:submit.prevent="onSubmit">
              <transition name="fade-in" mode="out-in" appear>
                <div v-if="this.step === 0" key="user-register" class="user-form">
                  <form-group v-bind:error="formErrors.first('displayname')">
                    <label for="displayname font-size-24">{{ $t('account.labels.displayName') }}</label>
                    <input type="text" class="form-control input-lg" id="displayname" :placeholder="$t('account.labels.displayName')" v-model="user.displayname">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('email')">
                    <label for="email">{{ $t('account.labels.email') }}</label>
                    <input type="email" class="form-control input-lg" id="email" :placeholder="$t('account.labels.email')" v-model="user.email">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('password')">
                    <label for="password">{{ $t('account.labels.password') }}</label>
                    <input type="password" class="form-control input-lg" id="password" :placeholder="$t('account.labels.password')" v-model="user.password">
                  </form-group>
                  </nav>
                  <button type="submit" class="btn btn-block btn-primary btn-lg btn-submit">
                    {{ $t("action.continue") }} <span class="glyphicon glyphicon-chevron-right"></span>
                  </button>
                </div>
                <div v-if="this.step === 1" key="team-register" class="default-form">
                  <form-group v-bind:error="formErrors.first('team')">
                    <label for="team">{{ $t('team.displayName.labels') }}</label>
                    <input type="text" class="form-control input-lg" id="team" placeholder="Team Display name" v-model="user.team">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('namespace')">
                    <label for="namespace">{{ $t('team.url.labels') }} <span class="grey-400 font-size-12">{{ $t('team.url.textGuide') }}</span></label>
                    <div class="input-group">
                      <div class="input-group-addon">{{`${baseURL}/`}}</div>
                      <input type="text" class="form-control input-lg" id="namespace" placeholder="Team URL" v-model="user.namespace">
                    </div>
                  </form-group>
                  <form-group v-bind:error="formErrors.first('accept')">
                    <div class="checkbox-custom checkbox-primary m-b-0 m-t-20 text-xs-left">
                      <input type="checkbox" v-model="user.accept">
                      <label for="term">{{ $t("register.labels.acceptTerm") }} <a href="https://www.byteark.com/terms-of-service/" target="_blank" class="p-0 m-0">{{ $t("register.labels.termOfService") }}</a></label>
                    </div>
                  </form-group>
                  <button type="submit" class="btn btn-block btn-primary btn-lg btn-submit" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                    <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> {{ $t('action.register') }}
                  </button>
                </div>
                <div v-if="this.step === 2" key="completed-register" class="default-form">
                  <div class="alert alert-success" role="alert">
                    <p>{{ $t('register.success') }} {{user.email}}</p>
                  </div>
                </div>
              </transition>
            </form>
            <p v-if="(this.step < 2)" class="text-center">{{ $t("account.labels.existingAccount") }}<u><router-link to="login" class="btn btn-link btn-register">{{ $t("action.login") }}</router-link></u></p>
          </div>
        </div>
        <footer class="page-copyright page-copyright-inverse">
          <p>Service by ByteArk</p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import AuthManager from '../../managers/AuthManager';

export default {
  components: {
    Alert,
    FormGroup,
  },
  watch: {
    'user.team': function() {
      if (this.formErrors.has('team')) {
        this.formErrors.remove('team');
      }
    },
    'user.namespace': function() {
      if (this.user.namespace) {
        this.user.namespace = this.user.namespace.toLowerCase();
      }
      if (this.formErrors.has('namespace')) {
        this.formErrors.remove('namespace');
      }
    },
    'user.email': function() {
      if (this.formErrors.has('email')) {
        this.formErrors.remove('email');
      }
    },
    'user.displayname': function() {
      if (this.formErrors.has('displayname')) {
        this.formErrors.remove('displayname');
      }
    },
    'user.password': function() {
      if (this.formErrors.has('password')) {
        this.formErrors.remove('password');
      }
    },
    'user.accept': function(value) {
      if (this.formErrors.has('accept')) {
        this.formErrors.remove('accept');
      }

      if (!value) {
        this.user.accept = null;
      }
    },
  },
  computed: {
    baseURL: () => process.env.BASE_URL,
  },
  data: function () {
    return {
      step: 0,
      authManager: null,
      validator: null,
      formErrors: null,
      showAlert: false,
      errorResponse: null,
      isSubmiting: false,
      user: {
        team: null,
        namespace: null,
        email: null,
        displayName: null,
        password: null,
        accept: null,
      },
    };
  },
  created: function() {
    this.authManager = new AuthManager();

    this.validator = new Validator();
    this.validator.attach('team', 'required|max:72', { prettyName: 'team name' });
    this.validator.attach('namespace', 'required|namespace|min:3|max:32', { prettyName: 'Team URL' });
    this.validator.attach('email', 'required|email');
    this.validator.attach('displayname', 'required', { prettyName: 'display name' });
    this.validator.attach('password', 'required|min:6');
    this.validator.attach('accept', 'required', { prettyName: 'Accept Terms of Service' });

    this.$set(this, 'formErrors', this.validator.errorBag);

    this.isRegisterFailed = false;
  },
  methods: {
    onSubmit: function () {
      if (this.step === 0) {
        this.validator.validateAll({
          displayname: this.user.displayname,
          email: this.user.email,
          password: this.user.password,
        }).then((success) => {
          if (!success) {
            return;
          }
          this.step = 1;

          // auto set display name to team
          this.user.team = this.user.displayname;
        }).catch(() => {
        });
      } else {
        this.clearErrors();

        this.validator.validateAll({
          team: this.user.team,
          namespace: this.user.namespace,
          displayname: this.user.displayname,
          email: this.user.email,
          password: this.user.password,
          accept: this.user.accept,
        })
        .then((success) => {
          if (!success) {
            return;
          }

          this.isSubmiting = true;
          this.showAlert = false;
          this.errorResponse = null;

          axios.post('/api/registrations', {
            name: this.user.team,
            namespace: this.user.namespace,
            email: this.user.email,
            display_name: this.user.displayname,
            password: this.user.password,
          })
          .then(() => {
            this.isSubmiting = false;
            this.clearErrors();

            // move to completed step
            this.step = 2;
          })
          .catch((error) => {
            this.isSubmiting = false;
            if (error.response.status === 422) {
              this.formErrors.addAll(error.response.data);
              this.errorResponse = this.$t('register.failed');
            } else {
              this.errorResponse = this.$t('register.failed');
            }
            this.showAlert = true;
          });
        })
        .catch(() => { });
      }
    },
    clearErrors: function () {
      this.showAlert = false;
      this.formErrors.clear();
      this.errorResponse = null;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Register.vue?eb58dc92